import { useRef, useLayoutEffect } from 'react';
import { Link, useLocation } from 'react-router';
import { NavigateRoutes } from '@features/routing/routesObject';
import logo from '@assets/images/logo.webp';
import SmallMenu from '@layouts/main-layout/header/small-menu/SmallMenu';
import BigMenu from '@layouts/main-layout/header/big-menu/BigMenu';
import OrderMenu from '@layouts/main-layout/header/order-menu/OrderMenu';



const Header = () => {

	const { pathname } = useLocation();
	const headerRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		headerRef?.current?.scrollIntoView();
	}, [ pathname, headerRef ]);

	return (
		<div className='app-header' ref={headerRef}>

			<SmallMenu />
			
			<div className='header-section logo-section'>
				
				<Link to={NavigateRoutes.basePath} className='main-logo disable-selection'>
					<img src={logo} alt='main-logo' />
				</Link>
			
			</div>

			<BigMenu />

			
			<OrderMenu />

		</div>
	);
}

export default Header;